import React, { useState, useCallback, useEffect, memo } from 'react';

import Dialog from '@smart-tv/components/dialog';
import ImageRight from '@smart-tv/components/image/image-right';
import testIds from '@smart-tv/e2e/shared/variables';
import loginCover from '@smart-tv/scaffold/images/lady-with-remote.png';
import { ForgotPasswordText } from '@smart-tv/pages/login/types';
import { getAppTextKMM, appTextKeys } from '@smart-tv/utils/kmm/getAppText';
import styles from '../login.module.scss';
import LoginForgotPasswordDialogForm from './login-forgot-password-dialog-form';
import LoginForgotPasswordDialogSucces from './login-forgot-password-dialog-succes';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const LoginForgotPasswordDialog = (props: Props) => {
  const { onClose, open } = props;
  const [forgotPwText, setForgotPwText] = useState<ForgotPasswordText>();
  const [resetPasswordEmail, setResetPasswordEmail] = useState('');
  const [resetPasswordSuccess, setPasswordResetSuccess] = useState(false);
  const getForgotPasswordText = useCallback(async () => {
    try {
      const kmmData = await getAppTextKMM(appTextKeys.forgotPassword);
      setForgotPwText(kmmData);
    } catch (error) {
      console.error('Error fetching forgot password text:', error);
    }
  }, []);

  useEffect(() => {
    getForgotPasswordText();
  }, [getForgotPasswordText]);

  const handleResetPassword = useCallback((resetPasswordEmail: string) => {
    setPasswordResetSuccess(true);

    setResetPasswordEmail(resetPasswordEmail);
  }, []);

  const handleClose = useCallback(() => {
    setPasswordResetSuccess(false);

    onClose();
  }, [onClose]);

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      data-testid={testIds.login.forgotPasswordDialog.dialog}
      showCloseButton={false}
    >
      <div className={styles['login-forgot-password-dialog']}>
        <LoginForgotPasswordDialogForm
          onSubmit={handleResetPassword}
          display={!resetPasswordSuccess}
          forgotPwText={forgotPwText?.initial}
          onClose={handleClose}
        />
        <LoginForgotPasswordDialogSucces
          onClose={handleClose}
          display={resetPasswordSuccess}
          resetPasswordEmail={resetPasswordEmail}
          forgotPwText={forgotPwText}
        />
      </div>
      <ImageRight cover={loginCover} />
    </Dialog>
  );
};

export default memo(LoginForgotPasswordDialog);
